import { generateProductLinkPropsForLoggedOutRetailer } from "@faire/retailer-visitor-shared/lib/generateProductLinkPropsForLoggedOutRetailer";
import { isAdmin } from "@faire/retailer-visitor-shared/lib/isAdmin";
import { isLoggedInRetailer } from "@faire/retailer-visitor-shared/lib/isLoggedInRetailer";
import { brandPage } from "@faire/retailer-visitor-shared/paths/index";
import { ProductPagePaths } from "@faire/retailer-visitor-shared/paths/ProductPage";
import { getLocation } from "@faire/web--source/common/globals/getLocation";
import { moneyOrZero } from "@faire/web--source/common/money";
import { parseQueryParams } from "@faire/web--source/common/query-params/parseQueryParams";
import { isPrerender } from "@faire/web--source/common/user-agent/isPrerender";
export var buildTileFromLeanProductTile = function(productTile) {
    var _productTile_product, _productTile_product1, _productTile_badge_list;
    if (!(productTile === null || productTile === void 0 ? void 0 : (_productTile_product = productTile.product) === null || _productTile_product === void 0 ? void 0 : _productTile_product.name) || !(productTile === null || productTile === void 0 ? void 0 : (_productTile_product1 = productTile.product) === null || _productTile_product1 === void 0 ? void 0 : _productTile_product1.token) || !(productTile === null || productTile === void 0 ? void 0 : productTile.best_image)) {
        return undefined;
    }
    return {
        bestImage: productTile.best_image,
        images: productTile.images,
        name: productTile.product.name,
        token: productTile.product.token,
        wholesalePrice: moneyOrZero(productTile.min_option_wholesale_price),
        retailPrice: moneyOrZero(productTile.min_option_retail_price),
        promoPrice: productTile.min_option_wholesale_promo_price,
        to: ProductPagePaths.index(productTile.product.token),
        isHighlightedProductForPromotionalEvent: productTile.is_highlighted_product_for_promotional_event,
        badges: (_productTile_badge_list = productTile.badge_list) === null || _productTile_badge_list === void 0 ? void 0 : _productTile_badge_list.badges.filter(function(badge) {
            return badge.display_to_user;
        }),
        brandToken: productTile.product.brand_token
    };
};
export var handleGenerateProductLinkProps = function(productTile, location, queryParamOverrides) {
    return function() {
        var product = productTile === null || productTile === void 0 ? void 0 : productTile.product;
        if (!(product === null || product === void 0 ? void 0 : product.token)) {
            return {
                productUrl: ""
            };
        }
        var _getParsedParams = getParsedParams(), refS = _getParsedParams.refS, refC = _getParsedParams.refC;
        var productPageLink = ProductPagePaths.index(product.token, {
            refS: refS,
            refC: refC !== null && refC !== void 0 ? refC : queryParamOverrides === null || queryParamOverrides === void 0 ? void 0 : queryParamOverrides.refC
        });
        if (isLoggedInRetailer() || isAdmin()) {
            return {
                productUrl: productPageLink
            };
        }
        return generateProductLinkPropsForLoggedOutRetailer({
            productToken: product.token,
            brandToken: product.brand_token,
            location: location
        });
    };
};
export var handleGenerateBrandUrl = function(brandToken, productToken) {
    return function() {
        if (!brandToken) {
            return "";
        }
        if (isPrerender()) {
            return brandPage(brandToken);
        }
        var _getParsedParams = getParsedParams(), refS = _getParsedParams.refS, refC = _getParsedParams.refC;
        return productToken !== undefined ? brandPage(brandToken, {
            refS: refS,
            refC: refC,
            refP: [
                productToken
            ]
        }) : brandPage(brandToken, {
            refS: refS,
            refC: refC
        });
    };
};
export var getParsedParams = function() {
    var _getLocation;
    var _getLocation_search;
    var rawParams = parseQueryParams((_getLocation_search = (_getLocation = getLocation()) === null || _getLocation === void 0 ? void 0 : _getLocation.search) !== null && _getLocation_search !== void 0 ? _getLocation_search : "");
    return {
        refS: rawParams.getOrDefault("refS", undefined),
        refC: rawParams.getOrDefault("refC", undefined)
    };
};
